import { gql } from 'react-apollo';

export const updateChurch = gql`
  mutation updateChurch($input: UpdateChurchInput!) {
    updateChurch(input: $input) {
      church {
        id
        name
        size
        notes
        contact_person
        address_line_1
        address_line_2
        revival {
          id
          title
          image {
            default
          }
          preparationStartDate: preparation_start_date
          startDate: start_date
          endDate: end_date
        }
        pastors {
          edges {
            node {
              id
              name
              email
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/churches/mutations/updateChurch.js